import { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { UseDeliverycalendar } from "./UseDeliverycalendar";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ChangeParts from "./ChangeParts";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function DaysCalendar(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getCalendarMonths } = UseDeliverycalendar();
  const [indexes, setIndexes] = useState();
  const [dayRes, setDayRes] = useState();
  const [changeState, setChangeState] = useState({
    show: false,
    model: undefined,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.selectedMonth) {
      setProgress(true);
      getCalendarMonths(props.selectedMonth, (DeliveryTypes) => {
        let index = DeliveryTypes.weekCount * 7;
        setIndexes(index);
        setDayRes(DeliveryTypes);
      });
    }
  }, [props.selectedMonth]);

  return (
    dayRes && (
      <Box
        sx={{
          flexGrow: 1,
          width: isSmall ? "100%" : "40%",
          display: "flex",
          flexDirection: "column",
          mx: "auto",
          border: "1px solid #DCDCE4",
          borderRadius: 3,
          flexGrow: 1,
          p: 2,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography color="secondary" variant="subtitle1">
            {dayRes.title}
          </Typography>
        </Box>
        <Box
          sx={{ mt: 2, mb: 1 }}
          display="grid"
          gridTemplateColumns={`repeat(7, 1fr)`}
          gap={0}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              شنبه
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              یکشنبه
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              دوشنبه
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              سه شنبه
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              چهار شنبه
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              پنج شنبه
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography color="black" variant="subtitle2">
              جمعه
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{ height: "100%" }}
          display="grid"
          gridTemplateColumns={`repeat(7, 1fr)`}
          gap={1}
        >
          {Array.from(Array(indexes).keys()).map((index) => {
            let model = dayRes.days.find((m) => m.index == index + 1)
              ? dayRes.days.find((m) => m.index == index + 1)
              : "";
            var height;
            if (model && model.parts.length == 1) {
              height = "100%";
            }
            if (model && model.parts.length == 2) {
              height = "50%";
            }
            if (model && model.parts.length == 3) {
              height = "33.33333333333333%";
            }
            if (model && model.parts.length == 4) {
              height = "25%";
            }
            if (model && model.parts.length == 5) {
              height = "20%";
            }
            return (
              <Box
                key={index}
                onClick={() =>
                  setChangeState({
                    show: true,
                    model: model.parts,
                    day: model.day,
                    dayname: model.dayname,
                    dayDate: model.date.split("T")[0],
                  })
                }
                sx={{
                  border: "1px solid #e0e0e0",
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                {model.parts &&
                  model.parts.map((m, i) => {
                    return (
                      <Box
                        key={i}
                        sx={{
                          height: height,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          my: "auto",
                          bgcolor: m.state == true ? "#5fc94985" : "#ff000069",
                          borderBottom: model.parts[i + 1]
                            ? "1px solid #a1a1a175"
                            : "",
                        }}
                      ></Box>
                    );
                  })}
                <Box
                  sx={{
                    display: "flex",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                  }}
                >
                  <Typography variant="subtitle1">{model.day}</Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
        <Box></Box>
        {changeState.show && (
          <ChangeParts
            DeliveryType={
              props.selectedMonth?.deliveryType
                ? props.selectedMonth?.deliveryType
                : ""
            }
            dayName={dayRes.title}
            selectedMonth={props.selectedMonth}
            changeState={changeState}
            setChangeState={setChangeState}
            callback={(selectedMonth) => {
              setProgress(true);
              getCalendarMonths(selectedMonth, (DeliveryTypes) => {
                let index = DeliveryTypes.weekCount * 7;
                setIndexes(index);
                setDayRes(DeliveryTypes);
              });
            }}
          />
        )}
      </Box>
    )
  );
}
